import { KTIcon } from "../../../../_metronic/helpers";

const AdvocateModalHeader = ({
  user,
  setOpenAdvocateModal,
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <h2 className="fw-bolder">Change Marketing Commission</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setOpenAdvocateModal(false)
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { AdvocateModalHeader };
